export default {
  isOpen: false,
  component: null,
  props: {},
}
